export const flags = Object.freeze({
  rfi: {
    value: 'rfi',
    description: 'Request for information',
    redirectPath: '/',
  }
});
